import { useGetUserQuery } from "../../Api/attoDeskApi";

export interface ModulePermission {
  can_view: boolean;
  can_create: boolean;
  can_edit: boolean;
  can_delete: boolean;
}

type PermissionAction = "can_view" | "can_create" | "can_edit" | "can_delete";

/**
 * Hook that provides permission checking from the current user's role.
 * Relies on RTK Query cache — no extra network calls.
 */
export const usePermissions = () => {
  const { data, isLoading } = useGetUserQuery();
  const userData = (data as any)?.data;
  const permissions: Record<string, ModulePermission> = userData?.permissions ?? {};
  const roleName: string = userData?.role_name ?? "";
  const isAdmin = roleName === "Admin";
  // While permissions are still loading, allow everything to avoid flash-of-empty-state
  const loaded = !isLoading && !!data;

  const hasPermission = (module: string, action: PermissionAction = "can_view"): boolean => {
    if (!loaded) return true; // still loading — show everything, guard kicks in once loaded
    if (isAdmin) return true;
    return !!permissions[module]?.[action];
  };

  return { permissions, roleName, isAdmin, hasPermission, loaded };
};
